import React from 'react';
import ModernCTA from '../../components/ModernCTA';

const WebPromotionSEO = () => {
  return (
    <div className="seo-promotion-page">
      {/* Pure CSS Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="eyebrow">DIGITAL GROWTH ENGINE</div>
            <h1>
              <span className="gradient-text">Enterprise SEO</span> 
              <span className="animated-underline">Solutions</span>
            </h1>
            <p className="subtitle">
              Technical audits, content clusters, and AI-powered keyword strategy for sustainable organic growth
            </p>
            <div className="keyword-bubbles">
              <span className="bubble">Technical SEO</span>
              <span className="bubble">Content Strategy</span>
              <span className="bubble">AI Analysis</span>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Services Grid */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">OUR METHODOLOGY</div>
            <h2>Data-Driven <span className="highlight">SEO Framework</span></h2>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🛠️</div>
              <h3>Technical Optimization</h3>
              <div className="service-features">
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Site architecture audit</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Core Web Vitals tuning</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Structured data implementation</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Crawl efficiency analysis</span>
                </div>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon">📝</div>
              <h3>Content Strategy</h3>
              <div className="service-features">
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Topic cluster development</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Semantic content mapping</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Search intent optimization</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Content gap analysis</span>
                </div>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon">🤖</div>
              <h3>AI-Powered Insights</h3>
              <div className="service-features">
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Predictive keyword modeling</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Competitor SERP analysis</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Opportunity forecasting</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Algorithm update monitoring</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Process */}
      <section className="process-section">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">OUR PROCESS</div>
            <h2>Proven <span className="highlight">SEO Growth</span> Framework</h2>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-marker"></div>
              <div className="step-content">
                <div className="step-number">01</div>
                <h3>Discover</h3>
                <p>Comprehensive technical & content audit</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-marker"></div>
              <div className="step-content">
                <div className="step-number">02</div>
                <h3>Analyze</h3>
                <p>Competitor benchmarking & gap analysis</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-marker"></div>
              <div className="step-content">
                <div className="step-number">03</div>
                <h3>Strategize</h3>
                <p>AI-powered keyword mapping</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-marker"></div>
              <div className="step-content">
                <div className="step-number">04</div>
                <h3>Optimize</h3>
                <p>Technical fixes & content development</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-marker"></div>
              <div className="step-content">
                <div className="step-number">05</div>
                <h3>Scale</h3>
                <p>Ongoing monitoring & expansion</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Results */}
      <section className="results-section">
        <div className="container">
          <div className="results-grid">
            <div className="result-card">
              <div className="result-value">3-6x</div>
              <div className="result-label">Organic Traffic Growth</div>
            </div>
            <div className="result-card">
              <div className="result-value">70%+</div>
              <div className="result-label">Keyword Ranking Gains</div>
            </div>
            <div className="result-card">
              <div className="result-value">50%+</div>
              <div className="result-label">Conversion Rate Lift</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta-section">
        <ModernCTA />
      </section>

      {/* Styles */}
      <style jsx="true">{`
        .seo-promotion-page {
          --primary: #6366f1;
          --primary-light: #818cf8;
          --dark-bg: #0f172a;
          --darker-bg: #020617;
          --card-bg: #1e293b;
          --text-light: #f8fafc;
          --text-muted: #94a3b8;
          
          margin-top: 80px;
          color: var(--text-light);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          background: var(--darker-bg);
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        
        /* Hero Section */
        .hero-section {
          padding: 80px 0;
          position: relative;
          overflow: hidden;
        }
        
        .hero-section::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -20%;
          width: 140%;
          height: 200%;
          background: radial-gradient(circle, rgba(99, 102, 241, 0.05) 0%, transparent 60%);
          z-index: -1;
        }
        
        .hero-content {
          max-width: 800px;
          margin: 0 auto;
          text-align: center;
        }
        
        .eyebrow {
          display: inline-block;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--primary-light);
          margin-bottom: 1rem;
          padding: 6px 12px;
          background: rgba(129, 140, 248, 0.1);
          border-radius: 20px;
        }
        
        h1 {
          font-size: 2.5rem;
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
        
        .gradient-text {
          background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
        .animated-underline {
          position: relative;
          display: inline-block;
          margin-left: 8px;
        }
        
        .animated-underline::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.3s ease;
        }
        
        .hero-section:hover .animated-underline::after {
          transform: scaleX(1);
        }
        
        .subtitle {
          font-size: 1.1rem;
          color: var(--text-muted);
          max-width: 600px;
          margin: 0 auto 2rem;
          line-height: 1.6;
        }
        
        .keyword-bubbles {
          display: flex;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: 30px;
        }
        
        .bubble {
          padding: 6px 12px;
          background: rgba(129, 140, 248, 0.1);
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
          color: var(--primary-light);
          animation: float 3s ease-in-out infinite;
        }
        
        .bubble:nth-child(1) { animation-delay: 0s; }
        .bubble:nth-child(2) { animation-delay: 0.5s; }
        .bubble:nth-child(3) { animation-delay: 1s; }
        
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        
        /* Services Section */
        .services-section {
          padding: 60px 0;
          background: var(--dark-bg);
        }
        
        .section-header {
          text-align: center;
          margin-bottom: 40px;
        }
        
        h2 {
          font-size: 2rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.3;
        }
        
        .highlight {
          background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
        .services-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
        }
        
        .service-card {
          background: var(--card-bg);
          border-radius: 12px;
          padding: 30px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        }
        
        .service-icon {
          font-size: 2rem;
          margin-bottom: 15px;
        }
        
        .service-card h3 {
          font-size: 1.3rem;
          margin-bottom: 20px;
        }
        
        .service-features {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        
        .feature {
          display: flex;
          align-items: flex-start;
          gap: 10px;
        }
        
        .feature-dot {
          width: 6px;
          height: 6px;
          background: var(--primary-light);
          border-radius: 50%;
          margin-top: 8px;
          flex-shrink: 0;
        }
        
        /* Process Section */
        .process-section {
          padding: 60px 0;
          position: relative;
        }
        
        .process-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(2, 6, 23, 0.9) 100%);
          z-index: -1;
        }
        
        .process-steps {
          display: flex;
          flex-direction: column;
          gap: 20px;
          max-width: 800px;
          margin: 0 auto;
          position: relative;
        }
        
        .process-step {
          display: flex;
          gap: 20px;
          position: relative;
        }
        
        .step-marker {
          width: 16px;
          height: 16px;
          background: var(--primary);
          border-radius: 50%;
          flex-shrink: 0;
          margin-top: 4px;
          position: relative;
        }
        
        .process-step:not(:last-child) .step-marker::after {
          content: '';
          position: absolute;
          top: 24px;
          left: 50%;
          transform: translateX(-50%);
          width: 2px;
          height: calc(100% + 20px);
          background: linear-gradient(to bottom, var(--primary) 0%, transparent 100%);
        }
        
        .step-content {
          padding-bottom: 20px;
        }
        
        .step-number {
          font-size: 0.9rem;
          font-weight: 600;
          color: var(--primary-light);
          margin-bottom: 8px;
        }
        
        .step-content h3 {
          font-size: 1.2rem;
          margin-bottom: 8px;
        }
        
        .step-content p {
          color: var(--text-muted);
          line-height: 1.6;
          font-size: 0.95rem;
        }
        
        /* Results Section */
        .results-section {
          padding: 60px 0;
          background: var(--dark-bg);
        }
        
        .results-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
          max-width: 1000px;
          margin: 0 auto;
        }
        
        .result-card {
          background: var(--card-bg);
          border-radius: 12px;
          padding: 30px 20px;
          text-align: center;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .result-value {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 8px;
          background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
        .result-label {
          font-size: 1rem;
          color: var(--text-muted);
        }
        
        /* Responsive Adjustments */
        @media (min-width: 480px) {
          .results-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (min-width: 640px) {
          .hero-section {
            padding: 100px 0;
          }
          
          h1 {
            font-size: 3rem;
          }
          
          .subtitle {
            font-size: 1.2rem;
          }
          
          .services-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .result-card {
            padding: 40px 20px;
          }
          
          .result-value {
            font-size: 3rem;
          }
        }
        
        @media (min-width: 768px) {
          .seo-promotion-page {
            margin-top: 115px;
          }
          
          .hero-section {
            padding: 120px 0;
          }
          
          h1 {
            font-size: 3.5rem;
          }
          
          .eyebrow {
            font-size: 0.875rem;
          }
          
          .subtitle {
            font-size: 1.25rem;
          }
          
          .services-section {
            padding: 100px 0;
          }
          
          .services-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
          }
          
          .service-card {
            padding: 40px;
            border-radius: 16px;
          }
          
          .process-section {
            padding: 100px 0;
          }
          
          .process-steps {
            gap: 30px;
          }
          
          .process-step {
            gap: 30px;
          }
          
          .step-marker {
            width: 20px;
            height: 20px;
          }
          
          .results-section {
            padding: 100px 0;
          }
          
          .results-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
          }
          
          .result-card {
            padding: 50px 30px;
            border-radius: 16px;
          }
          
          .result-value {
            font-size: 3.5rem;
          }
        }
        
        @media (min-width: 1024px) {
          h1 {
            font-size: 3rem;
          }
          
          h2 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default WebPromotionSEO;